// src/pages/ProfilePage.js
import React from 'react'

function ProfilePage() {
  return (
    <div style={{ padding: '1rem' }}>
      <h2>Profile</h2>
      <p>Willkommen in deinem Profil!</p>
    </div>
  )
}

export default ProfilePage
